import { ComponentType } from 'react';
import Loadable from './loadable';

export { default as BackTop } from './back-top';
/* ecode自定义组件运行视图 */
export { default as CustomComView } from './CustomComView';
export * from './CustomPageContext';
export * from './styled';
export const CustomPageWrap = Loadable({
  name: 'ComView',
  loader: () => import(
    /* webpackChunkName: "page_custompage" */
    './CustomPageWrap'
  ),
}) as ComponentType<any>;

export default {};
